import script from "./Logo.vue?vue&type=script&lang=ts&setup=true"
export * from "./Logo.vue?vue&type=script&lang=ts&setup=true"

import "./Logo.vue?vue&type=style&index=0&id=588975dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-588975dc"]])

export default __exports__